// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"2f1da1a5","115":"35fac82a","142":"e463cef8","231":"2f959659","289":"758adfcf","351":"285705ef","392":"282651dc","447":"bdd3c34b","453":"0c74b6df","517":"8cd06644","824":"3b28decc","900":"c3b2e256","970":"408fd04b"}[chunkId] + ".chunk.js";
};